import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-versionupdateddialog',
  standalone: false,
  templateUrl: './versionupdateddialog.component.html',
  styleUrl: './versionupdateddialog.component.css'
})
export class VersionUpdatedDialogComponent {
  dialogRef = inject<MatDialogRef<VersionUpdatedDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private dialog = inject(MatDialog);


  snooze() {
    this.dialogRef.close(false);
    setTimeout(() => {
      this.dialog.open(VersionUpdatedDialogComponent, null);
    }, 5 * 60 * 1000);
  }

  reload() {
    window.location.reload();
  }
}
